module.exports = __webpack_public_path__ + "static/media/POC fav icon.0ef060fc.svg";